import {useState, useCallback} from 'react'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import BasketMgr from '../custom-api/basket-custom-api'
import useMultiSite from './use-multi-site'
import useShipToCountry from './use-ship-to-country'

const usePdpDeliveryEstimations = () => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const {getTokenWhenReady} = useAccessToken()
    const {app: appConfig} = getConfig()
    const {site, locale} = useMultiSite()
    const {shipToCountry} = useShipToCountry()

    const fetchEstimations = useCallback(async () => {
        if (!site?.id || !locale?.id || !shipToCountry?.id) {
            return null
        }

        setLoading(true)
        setError(null)

        try {
            const basketMgr = new BasketMgr({
                parameters: {
                    siteId: site.id,
                    organizationId: appConfig.commerceAPI.parameters.organizationId,
                    locale: locale.id
                }
            })
            const accessToken = await getTokenWhenReady()
            const result = await basketMgr.getPdpDeliveryEstimations(
                accessToken,
                site.id,
                locale.id,
                shipToCountry.id
            )
            setData(result)
            return result
        } catch (err) {
            setError(err.message)
            return null
        } finally {
            setLoading(false)
        }
    }, [
        appConfig.commerceAPI.parameters.organizationId,
        getTokenWhenReady,
        locale?.id,
        shipToCountry?.id,
        site?.id
    ])

    return {data, loading, error, fetchEstimations}
}

export default usePdpDeliveryEstimations
